import { HttpClient } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialog, MatDialogConfig } from "@angular/material";
import { ToasterService } from "angular2-toaster";
import { BlockUI, NgBlockUI } from "ng-block-ui";
import { ReCaptchaV3Service } from "ng-recaptcha";
import { ErrorDialogComponent } from "src/app/components/dialog/error-dialog/error-dialog.component";
import { SuccessDialogComponent } from "src/app/components/dialog/success-dialog/success-dialog.component";
import { AbrirChamadoDTO } from "src/app/components/transferobjects/abertura-chamado/AbrirChamadoDTO";
import { TribunalOrigem } from "src/app/model/tribunalOrigem";

import { PadraoService } from "src/app/service/padrao/padrao.service";
import { isValidCpf } from "src/app/utils/shared/cpfValidator";
import { isValidEmail } from "src/app/utils/shared/emailValidator";
import { environment } from "../../../environments/environment";
import { TribunalOrigemService } from "../../service/carta-precatoria/tribunal-origem.service";

@Component({
  selector: "app-cadastro-carta-precatoria",
  templateUrl: "./cadastro-carta-precatoria.component.html",
  styleUrls: ["./cadastro-carta-precatoria.component.css"],
})
export class CadastroCartaPrecatoria implements OnInit {
  @BlockUI() loading: NgBlockUI;

  recaptcha: ReCaptchaV3Service;

  valido: boolean;
  registerForm: FormGroup;
  submitted = false;
  telMask: string;
  onLoad = false;

  nomeSistemas: any = [
    { id: "PJE", valor: "PJE" },
    { id: "PROJUDI", valor: "PROJUDI" },
  ];

  nomeServicos: any = [
    { id: "ALTERAÇÃO", valor: "ALTERAÇÃO" },
    { id: "CADASTRO", valor: "CADASTRO" },
    { id: "ERRO", valor: "ERRO" },
    { id: "INFORMAÇÃO", valor: "INFORMAÇÃO" },
  ];

  nomeTribunalOrigens = new Array<TribunalOrigem>();
  dominioTribunalSelecionado: string;
  chamadoDados: AbrirChamadoDTO;
  chamadoAberto: string;
  listaChamados: any[] = [];
  anexos: any[] = [];
  resposta: any;
  valorDialog: any;
  tamanhoPermitido: any = 19999854; //20971520;
  map = new Map();
  counter = 1;
  value = 0; // 20000000
  count = 0;
  element: HTMLElement;
  emailValido: boolean = false;

  constructor(
    private tribunalOrigemService: TribunalOrigemService,
    private formBuilder: FormBuilder,
    private padraoService: PadraoService,
    private dialog: MatDialog,
    private toast: ToasterService,
    private httpClient: HttpClient
  ) {}

  ngOnInit() {
    this.chamadoDados = new AbrirChamadoDTO();

    this.registerForm = this.formBuilder.group({
      nomeCompleto: [
        "",
        [
          Validators.required,
          Validators.minLength(5),
          Validators.maxLength(256),
        ],
      ],
      numeroCpf: [
        "",
        Validators.compose([
          Validators.required,
          Validators.minLength(11),
          isValidCpf(),
        ]),
      ],
      email: [
        "",
        Validators.compose([
          Validators.required,
          isValidEmail(this.tribunalOrigemService),
        ]),
      ],
      nomeTribunalOrigem: ["", [Validators.required, Validators.minLength(3)]],
      numeroTelefone: ["", [Validators.required, Validators.minLength(10)]],
      nomeSistema: ["", Validators.required],
      nomeServico: ["", Validators.required],
    });

    this.registerForm.get("nomeServico").setValue("CADASTRO");

    this.registerForm
      .get("numeroTelefone")
      .valueChanges.map((valor) => valor.length)
      .subscribe((length) => {
        if (length < 11) {
          this.telMask = "(00) 0000-00000";
        } else {
          this.telMask = "(00) 00000-0000";
        }
      });

      this.registerForm.get("nomeTribunalOrigem").valueChanges.subscribe((nomeTribunalSelecionado) => {
        const tribunalSelecionado = this.nomeTribunalOrigens.find(tribunal => tribunal.descTribunalOrigem === nomeTribunalSelecionado);
        const emailControl = this.registerForm.get("email");
        
        // Combine os validadores existentes com o novo validador
        emailControl.setValidators(Validators.compose([
          Validators.required,
          Validators.email,
          isValidEmail(tribunalSelecionado ? tribunalSelecionado.dominio : null)
        ]));
        
        emailControl.updateValueAndValidity();
      });

    // popula a combo Tribunal de Origem
    this.tribunalOrigemService.obterListaTribunais().subscribe((tribunais) => {
      this.nomeTribunalOrigens = tribunais;
      // this.nomeTribunalOrigens.sort((a, b) =>
      //   b.descTribunalOrigem > a.descTribunalOrigem ? -1 : 1
      // );
    });
  }

  /* fim evento para pegar o endereço do arquivo anexado em - tela anterior ao erro */
  get f() {
    return this.registerForm.controls;
  }

  limparForm() {
    this.ngOnInit();
    this.count = 0;
    this.counter = 1;
    this.anexos = [];
  }

  onSubmit() {
    this.submitted = true;
    this.listaChamados = [];
    if (this.registerForm.invalid) return;

    this.loading.start("Aguarde um momento...");

    if (this.registerForm.controls.nomeSistema.value.length == 2) {
      this.carregarDados(
        environment.idCategoriaPje,
        this.registerForm.controls.nomeSistema.value[0],
        this.registerForm.controls.nomeSistema.value.length
      );
      this.carregarDados(
        environment.idCategoriaProjudi,
        this.registerForm.controls.nomeSistema.value[1],
        this.registerForm.controls.nomeSistema.value.length
      );
    } else {
      if (this.registerForm.controls.nomeSistema.value[0] == "PJE") {
        this.carregarDados(
          environment.idCategoriaPje,
          this.registerForm.controls.nomeSistema.value[0],
          this.registerForm.controls.nomeSistema.value.length
        );
      }

      if (this.registerForm.controls.nomeSistema.value[0] == "PROJUDI") {
        this.carregarDados(
          environment.idCategoriaProjudi,
          this.registerForm.controls.nomeSistema.value[0],
          this.registerForm.controls.nomeSistema.value.length
        );
      }
    }
  }

  carregarDados(id, nomeSistema, tamanho) {
    this.chamadoDados.cr.category.id = id;
    this.chamadoDados.cr.customer.name = "";
    this.chamadoDados.cr.description =
      "\n\nDADOS SOLICITAÇÃO" +
      "\n\n - Distribuidor Carta Precatória -" +
      "\n\n || " +
      "Nome completo: " +
      this.registerForm.controls.nomeCompleto.value +
      "\n\n || " +
      "CPF: " +
      this.registerForm.controls.numeroCpf.value +
      "\n\n || " +
      "Nome do sistema: " +
      nomeSistema +
      "\n\n || " +
      "Nome do serviço: " +
      this.registerForm.controls.nomeServico.value +
      "\n\n || " +
      "Tribunal Origem: " +
      this.registerForm.controls.nomeTribunalOrigem.value;
    this.chamadoDados.cr.type.REL_ATTR = "";
    this.chamadoDados.cr.z_alt_phone_number =
      this.registerForm.controls.numeroTelefone.value;
    this.chamadoDados.cr.cidade.id = "";
    this.chamadoDados.cr.lotacao.id = "";
    this.chamadoDados.cr.zs_email_preferencial =
      this.registerForm.controls.email.value;
    this.chamadoDados.cr.group.name = "COATE_SISTEMAS_N2";

    this.padraoService
      .abrirChamado(JSON.stringify(this.chamadoDados), this.anexos)
      .subscribe(
        (response) => {
          this.listaChamados.push(response);

          if (this.listaChamados.length === tamanho) {
            this.loading.stop();
            this.abrirRespostaSucesso(
              this.listaChamados.map((elem) => elem).join(", ")
            );
            this.limparForm();
          }
        },
        (error) => {
          this.loading.stop();
          this.abrirRespostaErro(error);
        }
      );
  }

  abrirRespostaSucesso(resposta: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { valor: resposta };
    dialogConfig.width = "600px";
    dialogConfig.height = "380px";
    dialogConfig.panelClass = "custom-dialog";
    this.dialog.open(SuccessDialogComponent, dialogConfig);
  }

  abrirRespostaErro(resposta: any) {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = true;
    dialogConfig.disableClose = true;
    dialogConfig.data = { valor: resposta };
    dialogConfig.width = "600px";
    dialogConfig.height = "380px";
    this.dialog.open(ErrorDialogComponent, dialogConfig);
  }

  formName = this.formBuilder.group({
    controllerArray: this.formBuilder.array([]),
  });

  public removerEspaco(formGroup: FormGroup) {
    Object.keys(formGroup.controls).forEach((key) =>
      formGroup.get(key).setValue(formGroup.get(key).value.trim())
    );
  }
}
